const $ = require("jquery");
const firebase = require("firebase/app");
const io = require('socket.io-client');
const config = require('../config.js');

require("firebase/database");

import 'babel-polyfill';
const axios = require('axios');
import {GoogleCharts} from 'google-charts';

const sensibility = 4.0;

let currentParams = {};

const draw = function () {
  drawBaroRadar();
  drawHistoricScatter();

  for (var i = 0; i < 5; i++) {
    $("#lbl-range-" + i).html(Math.round(currentParams.radar.range[i]*10)/10);
    $("#lbl-snr-" + i).html(Math.round(currentParams.radar.snr[i]));
  }

  $("#lbl-hbmp").html(Math.round(currentParams.hbmp*10)/10);
  $("#lbl-deviation").html(Math.round(Math.min(...Object.values(currentParams.radar.deviation))*10)/10);
}

const init = function () {
  window.socket = io(config.socketServer[localStorage.sat]);

  currentParams = {
    radar: {
      snr: {
        0:0,
        1:0,
        2:0,
        3:0,
        4:0
      },
      range: {
        0:40,
        1:30,
        2:70,
        3:76,
        4:50
      },

      deviation: {
        0:50.4,
        1:30,
        2:70,
        3:76,
        4:50
      },
    },
    hbmp: 43
  }

  /*for (var i = 0; i < 5; i++) {
    let x = currentParams.radar.range[i];
    currentParams.radar.deviation[i] = Math.abs(x - currentParams.hbmp);
  }*/

  socket.on("radar", function (e) {
    currentParams.radar = e;
    currentParams.radar.deviation = [];
    for (var i = 0; i < 5; i++) {
      let x = currentParams.radar.range[i];
      let snr = currentParams.radar.snr[i];
      if(x === 0) {
        break;
      }
      packets.push([x, snr]);
      currentParams.radar.deviation[i] = Math.abs(x - currentParams.hbmp);
    }
    console.log(currentParams.radar);
    draw();
  });

  socket.on("hbmp", function (h) {
    currentParams.hbmp = h;
    draw();
  });

  draw();

  socket.emit("resend")
}

const drawBaroRadar = function () {
  let dataArray = [
    ['Origin', 'Range (m)', { role: 'style' } ],
    ['Barometric sensor', currentParams.hbmp, 'color: DarkBlue'],
  ]

  for (var i = 0; i < 5; i++) {
    let title = "Target #" + (i+1);
    let deviation = currentParams.radar.deviation[i];
    let style = "color: FireBrick;";
    let x = currentParams.radar.range[i];
    if(x !== 0){
      if(deviation === Math.min.apply(null, Object.values(currentParams.radar.deviation))){
        style = "color: gold;";
      }

      if(deviation <= sensibility) {
        style = "color: green;";
      }
    }
    dataArray.push([title, x, style])

  }

  var data = GoogleCharts.api.visualization.arrayToDataTable(dataArray);

  var options = {
    title: 'Comparision barometric vs uRAD',
    hAxis: {
      title: '',
      format: 'h:mm a',
      viewWindow: {
        min: [7, 30, 0],
        max: [17, 30, 0]
      }
    },
    vAxis: {
      title: 'Range (m)',
      viewWindow: {
        max: 200,
        min: 0
      }
    },
    legend:"none"
  };

  var chart = new GoogleCharts.api.visualization.ColumnChart(document.getElementById('chart_div'));

  chart.draw(data, options);
}
let packets = [];
const drawHistoricScatter = function () {
  packets = packets.slice(-20);
  let dataArray = [
    ['SNR', 'Range'],
    ...packets
  ];

  console.log(dataArray);
  var data = GoogleCharts.api.visualization.arrayToDataTable(dataArray);
  data.addRows(packets);

  var options = {
    title: 'SNR vs. Range',
    hAxis: {title: 'Range (m)', minValue: 0, maxValue: 200},
    vAxis: {title: 'SNR (dB)', minValue: 0, maxValue: 45},
    legend: 'none',
  };

  var chart = new GoogleCharts.api.visualization.ScatterChart(document.getElementById('historicScatter'));

  chart.draw(data, options);

}

GoogleCharts.load(init);
